module.exports = __webpack_public_path__ + "img/744.dc7e9316.jpg";